import React from "react";
import { Accordion, Checkbox } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var ProvisionalFilterAccordion = function (_a) {
    var titleType = _a.titleType, checked = _a.checked, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Accordion, { label: formatMessage({ id: "ui-br-legaldeposits.filter.provisional" }), separator: false },
        React.createElement(Checkbox, { label: formatMessage({
                id: titleType === "PERIODICAL"
                    ? "ui-br-legaldeposits.filter.provisional.onlyProvisionalPeriodicals"
                    : "ui-br-legaldeposits.filter.provisional.onlyProvisional",
            }), checked: checked, onChange: function (e) {
                return onChange(e.target.checked);
            } })));
};
